const EventEmitter = require('eventemitter3');

const StandardStrike = require('../StandardStrike');
const BattleCalc = require('../../BattleCalc');
const BattleEventFactory = require('../../events/BattleEventFactory');
const { logError } = require('../../logger');

const SkyHammer = function (battleState) {
  this.handle = 'sky_hammer';
  this.physical = true;
  this.movement = true;
  this.harm = true;
  this.weapon = true;

  this.eventEmitter = new EventEmitter();
  this.standardStrike = new StandardStrike(this, battleState);

  this.isLegal = function (actor, victim) {
    return victim.uid === actor.uid || (victim.tile && !victim.occupied);
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay || !victim) {
      return { success: false };
    }

    try {
      var ability = BattleCalc.getEquippedAbility(actor, this.handle);

      var oldTile = battleState.getTileAtCoords(actor.x, actor.y);

      if (victim.uid === actor.uid) {
        victim = oldTile;
      }

      oldTile.occupied = false;
      actor.x = victim.x;
      actor.y = victim.y;
      victim.occupied = true;

      var enemies = battleState.getEnemiesOfUnit(actor);
      var uVictims = [];
      for (var i = 0; i < enemies.length; ++i) {
        var enemy = enemies[i];
        if (enemy.inPlay && BattleCalc.boardDistance(victim, enemy) <= 2) {
          uVictims.push(enemy);
        }
      }

      var dist;
      var strikes = [];
      var knockbacks = [];

      // setTimeout( () => {
      for (var j = 0; j < uVictims.length; ++j) {
        var uVictim = uVictims[j];
        dist = BattleCalc.boardDistance(victim, uVictim);

        var strike = this.standardStrike.execute(
          actor,
          uVictim,
          ability.damage / dist,
          false
        );

        if (strike.success && !victim.dead) {
          knockbacks.push(
            BattleEventFactory.makeKnockbackEvent(
              battleState,
              battleState.getTileAtCoords(actor.x, actor.y),
              uVictim,
              Math.max(1, ability.potency / dist)
            )
          );
        }

        strikes.push(strike);
      }
      // }, BattleCalc.getCooldown(actor)*0.3*1000 );

      this.eventEmitter.emit('result', {
        abilityHandle: this.handle,
        actorId: actor.uid,
        victimId: victim.uid,
        success: true,
        strikes,
        knockbacks,
        allPieces: battleState.allPieces,
      });
    } catch (err) {
      logError(err, {
        module: 'SkyHammer',
        func: 'execute',
        actor,
        victim,
      });
      return { success: false };
    }
  };
};
module.exports = SkyHammer;
